module.exports = __webpack_public_path__ + "img/pay_pos.26baa022.png";